<ng-container
    *transloco="let t; prefix: 'stAdvantageCalculator'"
    [formGroup]="form">
    <div class="mb-6">
        <button
            type="button"
            class="inline-flex items-center font-bold dark:text-white p-4 hover:text-primary-300"
            (click)="onBackBtnClick($event)">
            <big-icon
                [icon]="backIcon"
                [size]="'w-5'"
                class="mr-2 dark:fill-white"></big-icon>
            {{ isInitialState() || (!editFormIsShown() && !isInitialState()) ? t('label.backToYourData') : t('label.backToOverview') }}
        </button>
    </div>

    @if (editFormIsShown()) {
        <div class="mb-6">
            <big-service-tool-advantage-calculator-form
                [group]="form.controls.additionalInsurants.at(index())"
                [metadata]="metadata"
                [insurantIndex]="index() + 2"
                [insurantType]="'additional'"
                [hasBeenSubmitted]="hasBeenSubmitted()" />

            <div class="mt-10">
                <big-ui-button
                    [buttonStyle]="'primary'"
                    (clicked)="onSubmit($event)"
                    [type]="'submit'">
                    <span>{{ t(isEditMode() ? 'label.additionalInsurants.applyChanges' : 'label.additionalInsurants.submit') }}</span>
                </big-ui-button>
            </div>
        </div>
    } @else {
        <h3 class="h2">{{ t('additionalInsurants.title') }}</h3>
        <p
            class="mb-10"
            [innerHTML]="t('additionalInsurants.description')"></p>

        <h3 class="h2">{{ t('addedPerson', { count: form.controls.additionalInsurants.controls.length }) }}</h3>

        @if (isInitialState() && form.controls.additionalInsurants.controls.length === 0) {
            <p>{{ t('additionalInsurants.singleInsurantState') }}</p>
        } @else {
            <ul>
                @for (group of form.controls.additionalInsurants.controls; let index = $index; track $index; let isLast = $last) {
                    @if (group.controls.name.value && group.controls.gender.value && group.controls.age.value) {
                        <li class="flex flex-col md:flex-row gap-2 md:gap-4">
                            <div class="flex-1 break-all">
                                <div
                                    class="h5 text-primary px-6 py-4 bg-white dark:text-white dark:bg-primary-700 rounded-lg"
                                    [class.mb-0]="isLast">
                                    <span class="whitespace-nowrap mr-1">{{ group.controls.name.value }},</span>
                                    <span class="whitespace-nowrap mr-1">{{ t('label.selectedGender', { gender: group.controls.gender.value }) }},</span>
                                    <span class="whitespace-nowrap">{{ t('years', { years: group.controls.age.value }) }}</span>
                                </div>
                            </div>
                            <div class="flex items-start justify-between sm:justify-start md:items-center gap-1 sm:gap-4">
                                <big-ui-button
                                    (click)="onDelete(index)"
                                    [buttonStyle]="'tertiary'"
                                    role="button"
                                    type="button"
                                    [classList]="['flex items-center pt-1 mt-1 sm:p-1 sm:m-2']">
                                    <big-icon
                                        [icon]="deleteIcon"
                                        [size]="'w-5'"
                                        [title]="t('label.delete', { name: group.controls.name.value })"
                                        class="fill-primary-800 dark:fill-white hover:fill-primary-300"></big-icon>
                                    <span>{{ t('additionalInsurants.delete') }}</span>
                                </big-ui-button>
                                <big-ui-button
                                    (click)="onEdit(index)"
                                    [buttonStyle]="'tertiary'"
                                    role="button"
                                    type="button"
                                    [classList]="['flex items-center pt-1 mt-1 sm:p-1 sm:m-2']">
                                    <big-icon
                                        [icon]="editIcon"
                                        [size]="'w-5'"
                                        [title]="t('label.edit', { name: group.controls.name.value })"
                                        class="fill-primary-800 dark:fill-white hover:fill-primary-300"></big-icon>
                                    <span>{{ t('additionalInsurants.edit') }}</span>
                                </big-ui-button>
                            </div>
                        </li>
                    }
                }
            </ul>
        }

        <div class="mt-6">
            <big-ui-button
                [buttonStyle]="'secondary'"
                class="mt-10"
                [type]="'button'"
                (clicked)="onAddInsurantClick($event)">
                <big-icon
                    [icon]="iconPlus"
                    [size]="'w-4'"
                    class="hidden sm:block dark:fill-white"></big-icon>
                <span>{{ t('label.addInsurant') }}</span>
            </big-ui-button>
        </div>

        <div class="mt-10 text-center">
            <big-ui-button
                [buttonStyle]="'primary'"
                class="mt-10"
                [type]="'submit'"
                (clicked)="onGoToSummaryClick($event)">
                <span>{{ t('label.submit') }}</span>
            </big-ui-button>
        </div>
    }
</ng-container>
